/**
 * List of countries that require GDPR compliance
 * This includes EU member states and other countries with similar privacy laws
 */
export const GDPR_COUNTRIES = [
  // EU Member States
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  // EEA Countries (non-EU)
  'IS', // Iceland
  'LI', // Liechtenstein
  'NO', // Norway
  // Other countries with similar privacy laws
  'CH', // Switzerland (has adequacy decision)
  'GB', // United Kingdom (UK GDPR)
];

/**
 * Check if a country code requires GDPR compliance
 */
export const isGDPRCountry = (countryCode: string): boolean => {
  return GDPR_COUNTRIES.includes(countryCode.toUpperCase());
};
